import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PingIrsService {

  constructor(private http: HttpClient) { }

  pingIRS(efileApiUrl: string, envType: string): Observable<any> {
    const url = `${efileApiUrl.replace(/\/$/, '')}/pingServer?envType=${envType}`;
    return this.http.get<any>(url, { withCredentials: true });
  }
}
